import Box from "@mui/material/Box";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CallIcon from "@mui/icons-material/Call";
import ChatIcon from "@mui/icons-material/Chat";
import Typography from "@mui/material/Typography";
import React, { useCallback, useState } from "react";
import { Tabs, Tab,  } from "@mui/material";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import WatsappIcon from "../assets/images/apps/Watsapp.png";
// import Yellowish from "../assets/images/yellowishcircular.svg";
import SSSYmbolWhite from "../assets/images/sssymbolwhite.svg";
import qrcode from "../assets/images/watsappqrcode.png";
import "../assets/css/footer.css";
import "../assets/css/animated.css";
// import CircularRound from "../assets/images/circular lining.svg";
import { useResponsive } from "../hooks/use-responsive";
import ContactEmailForm from "../components/pages/ContactusForm/ContactEmailForm";
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
         
    );
}

function DashSupport() {
    const mdUp = useResponsive("up", "md");
    const [currentTab, setCurrentTab] = useState('chat');

    const handleChangeTab = useCallback((event, newValue) => {
      setCurrentTab(newValue);
    }, []);
    const styles = {
        typography: {
            fontFamily: "Sofia Sans Extra Condensed",
            fontSize: "50px",
            fontWeight: 700,
            lineHeight: "60px",
            letterSpacing: "0em",
            textAlign: "center",
            "@media (max-width: 600px)": {
                fontSize: "32px", // Adjust the font size for smaller screens
                textAlign: "center",
            },
        },
        // Other styles...
    };

    const smallContent = {
        typography: {
            fontFamily: "Roboto Flex",
            fontSize: "24px",
            fontWeight: 500,
            lineHeight: "27px",
            letterSpacing: "0em",
            "@media (max-width: 600px)": {
                fontSize: "18px", // Adjust the font size for smaller screens
                textAlign: "center",
            },
        },
        // Other styles...
    };

    const description = {
        typography: {
            fontFamily: "Roboto Flex",
            fontSize: "22px",
            fontWeight: 500,
            lineHeight: "27px",
            letterSpacing: "0em",
            "@media (max-width: 600px)": {
                fontSize: "16px",
                textAlign: "center",
            },
        },
    };
    const textStyle = {
        fontFamily: "Roboto Flex",
        fontWeight: 600,
        fontSize: "1rem",
        lineHeight: "25.6px",
        color: "#858585"
    };

    const VisuallyHiddenInput = styled("input")({
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: 1,
        overflow: "hidden",
        position: "absolute",
        bottom: 0,
        left: 0,
        whiteSpace: "nowrap",
        width: 1,
    });

    return (
        <>
            <Box sx={{ p: {xs:1 ,sm:2, md:2}, backgroundColor: '#F1F1F1', borderRadius: 5, }}>

                <Typography
                    variant="h4"
                    sx={{
                        fontFamily: "Sofia Sans Extra Condensed",
                        fontWeight: 700,
                        color: "#1E53E8",
                        textTransform: "uppercase",
                    }}
                >
                    Support
                </Typography>
                <Box sx={{ p: {xs:0 ,sm:0, md:5}, mt: 3, backgroundColor: '#FFFFFF', borderRadius: 5, }}>
                    <Typography
                        sx={{
                            ...styles.typography,
                            color: "#1E53E8",
                            zIndex: 2,
                            textTransform: "uppercase",
                        }}
                    >
                        Need Assistance?
                    </Typography>

                    <Typography
                        sx={{
                            ...description.typography,
                            fontSize: "18px",
                            fontWeight: 400,
                            textAlign: "center",
                            marginBlock: "15px",
                            position: "relative",

                        }}
                    >
                        We're here to help! Our friendly support team is
                        just a click or call away.
                    </Typography>
                    <Tabs
                       value={currentTab}
                       onChange={handleChangeTab}
                        aria-label="icon tabs example"
                        centered
                        variant={mdUp ? 'standard' : 'scrollable'}
                        // variant="scrollable"
                        sx={{

                            backgroundColor: "",
                            marginTop: "40px",
                            

                        }}
                    >
                        <Tab
                          value= 'chat'
                            label={
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        // padding: "40px",
                                        gap: "10px",
                                        // marginBottom: "20px",
                                        // "@media (max-width: 800px)": {
                                        //     display: "flex",
                                        //     flexDirection: "row",
                                        //     padding: "0px",
                                        //     marginBottom: "20px"

                                        // },
                                    }}
                                >
                                    <ChatIcon sx={{
                                        color: "#000000", fontSize: "2.5rem",
                                        "@media (max-width: 800px)": {
                                            fontSize: "1.5rem"
                                        },
                                    }} />
                                    <Typography
                                        sx={{
                                            color: "#000000",
                                            fontFamily: "Sofia Sans Extra Condensed",
                                            fontSize: "40px",
                                            fontWeight: "700",
                                            "@media (max-width: 800px)": {
                                                fontSize: "1.5rem"
                                            },
                                        }}
                                    >
                                        Chat
                                    </Typography>
                                </Box>
                            }
                            sx={{
                                // padding: "15px",
                                // width: "100px",
                                // border: "2px solid #1E53E8",
                                // borderTopLeftRadius: "22px",
                                // borderTopRightRadius: "22px",
                                // backgroundColor: "#FFFFFF",
                                borderBottomLeftRadius: "0px",


                                "&.Mui-selected": {
                                    // backgroundColor: "#1E53E8",
                                    "& .MuiTypography-root": {
                                        color: "#1E53E8", // Yellow color for the label when selected

                                    },
                                    "& .MuiSvgIcon-root": {
                                        color: "#1E53E8", // Yellow color for the icon when selected
                                    },
                                },
                            }}
                        />
                        <Divider
                            orientation="vertical"
                            variant="middle"
                            flexItem
                            sx={{
                                mx: 2,
                                borderColor: '#858585',  
                                bgcolor: '#858585',      
                                width: '1px'             
                            }}
                        />

                        <Tab
                            value= 'email'
                            label={
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        // padding: "15px",
                                        gap: "10px",
                                        // marginBottom: "20px",
                                        // "@media (max-width: 800px)": {
                                        //     display: "flex",
                                        //     flexDirection: "row",
                                        //     padding: "20px",
                                        //     marginBottom: "20px"

                                        // },
                                    }}
                                >
                                    <MailOutlineIcon sx={{
                                        color: "#000000", fontSize: "2.5rem",
                                        "@media (max-width: 800px)": {
                                            fontSize: "1.5rem"
                                        },
                                    }} />
                                    <Typography
                                        sx={{
                                            color: "#000000",
                                            fontFamily: "Sofia Sans Extra Condensed",
                                            fontSize: "40px",
                                            fontWeight: "700",
                                            "@media (max-width: 800px)": {
                                                fontSize: "1.5rem"
                                            },
                                        }}
                                    >
                                        Email
                                    </Typography>
                                </Box>
                            }
                            sx={{
                                // padding: "15px",
                                // width: "100px",
                                // backgroundColor: "#FFFFFF",
                                // border: "2px solid #1E53E8",
                                // borderTopLeftRadius: "22px",
                                // borderTopRightRadius: "22px",
                                "&.Mui-selected": {
                                    // backgroundColor: "#1E53E8",
                                    "& .MuiTypography-root": {
                                        color: "#1E53E8", // Yellow color for the label when selected
                                    },
                                    "& .MuiSvgIcon-root": {
                                        color: "#1E53E8", // Yellow color for the icon when selected
                                    },
                                },
                            }}
                        />
                        <Divider
                            orientation="vertical"
                            variant="middle"
                            flexItem
                            sx={{
                                mx: 2,
                                borderColor: '#858585',  
                                bgcolor: '#858585',      
                                width: '1px'             
                            }}
                        />

                        <Tab
                           value= 'call'
                            label={
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        // padding: "15px",
                                        gap: "10px",
                                        // marginBottom: "20px",
                                        // "@media (max-width: 800px)": {
                                        //     display: "flex",
                                        //     flexDirection: "row",
                                        //     padding: "20px",
                                        //     marginBottom: "20px"
                                        // },
                                    }}
                                >
                                    <CallIcon sx={{
                                        color: "#000000", fontSize: "2.5rem",
                                        "@media (max-width: 800px)": {
                                            fontSize: "1.5rem"
                                        },
                                    }} />
                                    <Typography
                                        sx={{
                                            color: "#000000",
                                            fontFamily: "Sofia Sans Extra Condensed",
                                            fontSize: "40px",
                                            fontWeight: "700",
                                            "@media (max-width: 800px)": {
                                                fontSize: "1.5rem"
                                            },
                                        }}
                                    >
                                        Call
                                    </Typography>
                                </Box>
                            }
                            sx={{
                                padding: "25px",
                                // width: "100px",
                                // border: "2px solid #1E53E8",
                                // backgroundColor: "#FFFFFF",
                                // borderTopLeftRadius: "22px",
                                // borderTopRightRadius: "22px",
                                marginRight: "4px",
                                "& .MuiTab-root": {

                                },
                                "&.Mui-selected": {
                                    // backgroundColor: "#1E53E8",
                                    "& .MuiTypography-root": {
                                        color: "#1E53E8", // Yellow color for the label when selected
                                    },
                                    "& .MuiSvgIcon-root": {
                                        color: "#1E53E8", // Yellow color for the icon when selected
                                    },
                                },
                            }}
                        />
                    </Tabs>


                  {currentTab === 'chat' && <TabPanel >
                        <Box
                            sx={{
                                padding: "50px",
                                position: "relative",
                                zIndex: "1",
                                "@media screen and (max-width: 700px)": {
                                    padding: "0px", // Change width to 100% for screens <= 700px
                                },
                            }}
                        >
                            <Typography
                                sx={{
                                    ...description.typography,
                                    display: "flex",
                                    alignItems: "center",
                                    textAlign: "left",
                                    fontWeight: "500",
                                    marginBlock: "15px",
                                    fontSize: "24px",
                                    "@media screen and (max-width: 700px)": {
                                        // Change width to 100% for screens <= 700px
                                        marginBlock: "0px",
                                        justifyContent: "center",
                                        display: "flex",

                                    },
                                }}
                            >   Reach out on Whatsapp <img className="watsapp-image" src={WatsappIcon} alt="" />
                            </Typography>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Typography
                                    sx={{
                                        ...description.typography,
                                        textAlign: "left",
                                        marginBlock: "15px",
                                        fontWeight: "500",
                                        "@media screen and (max-width: 700px)": {
                                            // Change width to 100% for screens <= 700px
                                            marginBlock: "0px",
                                        },
                                    }}
                                >
                                    Mobile
                                </Typography>
                                <Typography
                                    sx={{
                                        ...description.typography,
                                        textAlign: "left",
                                        marginBlock: "15px",
                                        color: "#1D53E7",
                                        position: "relative",
                                        zIndex: "1",
                                        "@media screen and (max-width: 700px)": {
                                            // Change width to 100% for screens <= 700px
                                            marginBlock: "0px",
                                        },
                                    }}
                                >
                                    +91 6360003712
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    "@media screen and (max-width: 700px)": {
                                        // Change width to 100% for screens <= 700px
                                        marginTop: "30px"
                                    },
                                }}
                            >
                                <img
                                    src={qrcode}
                                    alt=""
                                    className="qrcode-in-the-contactus-page-responsiveness"
                                />
                                <Typography
                                    sx={{
                                        ...description.typography,
                                        textAlign: "center",
                                        marginBlock: "5px",
                                        fontSize: "1.2rem",
                                    }}
                                >
                                    Or just scan the QR Code above
                                </Typography>
                            </Box>
                            <Divider sx={{
                                marginTop: "20px", color: "black",
                                "@media screen and (max-width: 700px)": {
                                    // Change width to 100% for screens <= 700px
                                    marginTop: "60px"
                                },
                            }} />
                            <Typography
                                sx={{
                                    ...smallContent.typography,
                                    textAlign: "left",
                                    marginBlock: "15px",
                                }}
                            >
                                Live Chat with our Team
                            </Typography>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    position: "relative",
                                    zIndex: "1",
                                }}
                            >
                                <Typography
                                    sx={{
                                        ...description.typography,
                                        textAlign: "left",
                                        marginBlock: "15px",
                                        color: "#858585",
                                    }}
                                >
                                    Ask us Anything
                                </Typography>

                                <Button
                                    disabled
                                    sx={{
                                        fontFamily: "Roboto Flex",
                                        textAlign: "center",
                                        width: "186px",
                                        height: "54px",
                                        position: "relative",
                                        zIndex: "1",
                                        "@media screen and (max-width: 700px)": {
                                            // Change width to 100% for screens <= 700px
                                            width: "120px",
                                            height: "45px",
                                        },
                                    }}
                                    variant="contained"
                                >
                                    Live Chat
                                </Button>
                            </div>
                            {/* <img
                                src={CircularRound}
                                alt=""
                                style={{
                                    position: "absolute",
                                    bottom: "0",
                                    right: "-20px",
                                    width: "36%",
                                    zIndex: "-1",
                                }}
                            /> */}
                        </Box>
                    </TabPanel>}


                    {currentTab === 'email' &&   <TabPanel
                      
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <ContactEmailForm/>
                    </TabPanel>
                    }

                    {currentTab === 'call' &&  <TabPanel >
                        <Box
                            sx={{
                                padding: "50px",
                                position: "relative",
                                zIndex: "1",
                                "@media screen and (max-width: 700px)": {
                                    padding: "0px",
                                },
                            }}
                        >
                            <Typography
                                sx={{
                                    ...smallContent.typography,
                                    textAlign: "left",
                                    marginBlock: "15px",
                                }}
                            >
                                Call Us Anytime :  9:00 AM to 6:00PM
                            </Typography>
                            <Box
                                sx={{
                                    // padding: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    // justifyContent: "space-between",
                                    gap: "506px",
                                    marginTop: "40px",
                                    "@media screen and (max-width: 700px)": {
                                        gap: "4px",
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column"
                                    },
                                }}
                            >
                                <Typography
                                    sx={{
                                        ...description.typography,
                                        textAlign: "left",
                                        marginBlock: "5px",
                                    }}
                                >
                                    Customer support
                                </Typography>
                                <Typography
                                    sx={{
                                        ...description.typography,
                                        textAlign: "left",
                                        marginBlock: "5px",
                                        color: "rgba(29, 83, 231, 1)",
                                        position: "relative",
                                        zIndex: "1",
                                        "@media screen and (max-width: 700px)": {
                                            marginTop: "24px"
                                        },
                                    }}
                                >
                                    +91 6360003712
                                </Typography>
                            </Box>
                            {/* <div style={{padding:'10px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                            <Typography sx={{ ...description.typography, textAlign: 'left',
                            marginBlock: "15px",
                            color: '#858585'
                            }}>
                            Cloud PC related issue’s
                            </Typography>
                            <Typography sx={{ ...description.typography, textAlign: 'left',
                            marginBlock: "15px",
                            color: '#858585',position:'relative',zIndex:'1'
                            }}>
                            +91 6360003712
                            </Typography>
                            </div>
                            <div style={{padding:'10px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                            <Typography sx={{ ...description.typography,  textAlign: 'left',
                            marginBlock: "15px",
                            color: '#858585',position:'relative',zIndex:'1'
                            }}>
                            Complaint helpline number
                            </Typography>
                            <Typography sx={{...description.typography,   textAlign: 'left',
                            marginBlock: "15px",
                            color: '#858585',position:'relative',zIndex:'1'
                            }}>
                            +91 6360003712
                            </Typography>
                            </div> */}
                            {/* <img
                                src={CircularRound}
                                alt=""
                                style={{
                                    position: "absolute",
                                    bottom: "0",
                                    right: "-24px",
                                    width: "13%",
                                    zIndex: "0",
                                }}
                            /> */}
                        </Box>
                    </TabPanel>}
                </Box>
                <img
                    src={SSSYmbolWhite}
                    alt=""
                    className="s-symbol-used-in-the-resposnive-bottom-of-the-contactus"
                />
            </Box>
        </>
    );
}

export default DashSupport;
